import makeStyles from '@material-ui/core/styles/makeStyles';

const useStyles = makeStyles({
  root: {
    height: '100%',
    width: '100%',
    margin: '0px 15px'
  },
})

export default useStyles;